import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import UserType, { URL_DEFAULT_REDIRECT } from 'src/utils/constants/auth';
import { selectUserRedirectBySystemRol } from 'src/utils/common';
import { isRouteAllowedForRole } from 'src/utils/constants/permissions';
import { Navigate, useLocation } from 'react-router-dom';

const RolePrivateRoute = ({ component: Component }) => {
  const loggedIn = useSelector(state => state.auth.token !== null);
  const systemRole = useSelector(state => state.auth.system === UserType.ADMIN);
  const system = useSelector(state => state.auth.system);
  const role = useSelector(state => state.auth.role);
  const location = useLocation();

  if (!loggedIn) {
    window.location.replace(URL_DEFAULT_REDIRECT);
    return null;
  }

  if (!systemRole) {
    return (
      <Navigate
        to={selectUserRedirectBySystemRol(system)}
        state={{ referrer: location }}
        replace
      />
    );
  }

  const allowed = isRouteAllowedForRole(location.pathname, role);
  if (!allowed) {
    return (
      <Navigate
        to={selectUserRedirectBySystemRol(system)}
        state={{ referrer: location }}
        replace
      />
    );
  }

  return <Component />;
};

RolePrivateRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.func
  ])
};

export default RolePrivateRoute;
